
export class StringUtils
{
    public static ToTitleCase(str: string): string
    {
        return str.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }

    public static FormatName(name?: string): string
    {
        return this.ToTitleCase(name || "(brak nazwiska)").trim();
    }
}
